import React from "react";
import { Carousel, Badge } from "react-bootstrap";

const BookCard = ({ book, onClick }) => {
  const isLive = book.isLive;

  return (
    <div
      className={
        isLive ? "book-card-wrapper book-card-wrapper--live" : "book-card-wrapper"
      }
      onClick={!isLive ? onClick : undefined}
      role={!isLive ? "button" : undefined}
      tabIndex={!isLive ? 0 : undefined}
      onKeyDown={
        !isLive
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      <Carousel
        className="book-card-carousel"
        controls={false}
        indicators={false}
        interval={2200}
        fade
      >
        {book.images.map((src, idx) => (
          <Carousel.Item key={idx}>
            <img
              className="book-card-img"
              src={src}
              alt={`${book.title} ${idx + 1}`}
              loading="lazy"
            />
          </Carousel.Item>
        ))}
      </Carousel>

      <Badge
        className={
          isLive
            ? "book-card-badge book-card-badge--live"
            : "book-card-badge book-card-badge--soon"
        }
      >
        {isLive ? "Available Now" : "Coming Soon"}
      </Badge>

      <div className="book-card-overlay">
        <div className="book-card-title">{book.title}</div>
        <div className="book-card-tagline">{book.tagline}</div>

        {isLive && (
          <a
            className="ds-btn-secondary ds-btn--sm book-card-buy-btn"
            href={book.amazonLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="lni lni-cart"></i> Buy on Amazon
          </a>
        )}
      </div>
    </div>
  );
};

export default BookCard;
